// ABOUTME: Controller Stimulus para autenticação SSO com bibliotecas virtuais.
// ABOUTME: Generalizado para Minha Biblioteca (DLI) e Biblioteca Virtual (Pearson).

import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["form", "template", "alertContainer"]
  static values = { url: String }

  async redirect(event) {
    event.preventDefault();
    this.alertContainerTarget.innerHTML = '';

    const button = event.target;
    button.disabled = true;
    const buttonText = button.innerHTML;
    button.innerHTML = 'Processando...'
    setTimeout(() => {
      button.innerHTML = buttonText;
      button.disabled = false;
    }, 10_000);

    const response = await post(this.urlValue);
    if (response.ok) {
      const payload = await response.json;
      this.formTarget.action = payload.url;

      this.formTarget.querySelectorAll('input[type=hidden][data-dynamic]').forEach(i => i.remove());

      if (payload.params) {
        for (const [key, value] of Object.entries(payload.params)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          input.dataset.dynamic = 'true';
          this.formTarget.appendChild(input);
        }
      }

      this.formTarget.submit();
    } else {
      this.alertContainerTarget.innerHTML = this.templateTarget.innerHTML;
    }
  }
}
